import React, { useLayoutEffect, useRef } from 'react';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { CheckIcon, EditIcon } from '../../icons';
import { colors } from '../../constants';
import './manufacturingTable.css';

export function CommentFieldEdit(props) {
    const { api, id, value, field, hasFocus } = props;
    const apiRef = useGridApiContext();
    const ref = useRef();

    useLayoutEffect(() => {
        if (hasFocus) {
            ref.current.focus();
        }
    }, [hasFocus]);

    const handleValueChange = (event) => {
        const newValue = event.target.value;
        apiRef.current.setEditCellValue({ id, field, value: newValue });
    };

    const handleSave = () => {
        api.stopCellEditMode({ id, field });
    };

    return (
        <div className="d-flex align-items-center w-100 h-100 editFieldContainer">
            <textarea
                className="flex-grow-1 w-100 h-100 border-0 p-1"
                value={value}
                onChange={handleValueChange}
                ref={ref}
            /> 
            <button className="btn p-0 me-1 border-0" onClick={handleSave}>
                <CheckIcon color={colors.skyfallDark} size="20" />
            </button>
        </div>
    );
}

export function CommentFieldCell(props) {
    return (
        <div className="d-flex align-items-center w-100 gap-1">
            <div className="flex-grow-1 commentCellField">{props.value}</div>
            <div className="commentCellIcon">
                <EditIcon size="16px" color={colors.skyfallDark} />
            </div>
        </div>
    );
}
